// extracted by mini-css-extract-plugin
module.exports = {"select":"style_select__SCPkA","multiple":"style_multiple__1F4Wd"};